import classNames from 'classnames';
import React from 'react';

import { UmbracoClinicModel } from 'src/services/booking';
import { innerHtml } from 'src/utils/html';

type Props = {
    clinic: UmbracoClinicModel;
    className?: string;
};

export const ClinicBillingPolicy = ({ clinic, className }: Props) => {
    const billingPolicyHtml = clinic.pricingElements?.find((p) => p.title.trim() === 'Billing Policy')?.contentHtml;

    return (
        <div className={classNames('prose prose-sm text-gray-700', className)}>
            {billingPolicyHtml ? (
                <div className="prose prose-sm text-gray-700" {...innerHtml(billingPolicyHtml)} />
            ) : (
                <>
                    <p>
                        Full payment is required at consultation. If applicable, the Medicare rebate will be processed
                        onsite.
                    </p>
                </>
            )}
            <p>
                <strong className="font-semibold">
                    For detailed fee policy, view the{' '}
                    <a
                        target="_blank"
                        className="text-primary"
                        href={`${import.meta.env.VITE_MYHEALTH_WEBSITE}${clinic?.url}#pricing`}
                    >
                        centre's pricing policy
                    </a>
                </strong>{' '}
                or check with reception for updated pricing for any services that are in addition to a consultation.
            </p>
        </div>
    );
};
